import type { ReactElement } from 'react';
import { toCurrency } from 'utils/numbers';
import ISku from 'models/ISku';

type Props = {
  sku: ISku;
  price: number;
  isBundle: boolean;
  isPDPPackageProduct: boolean;
};

function ProductPackageSkuPrice({
  sku, price, isBundle,
  isPDPPackageProduct,
}: Props): ReactElement {
  const {
    spec,
    sales_price: salesPrice,
    servings,
    plan_group: planGroup,
    subscription_price_per_serving: subscriptionPricePerServing,
  } = sku;

  const servingText = servings && !isBundle && !isPDPPackageProduct
    ? (
      <>
        <span className="c-product-package-sku-price__bold">
          {toCurrency(subscriptionPricePerServing * servings)}
        </span>
        {' for '}
        <span>{servings}</span>
        {' servings'}
      </>
    )
    : (
      <span className="c-product-package-sku-price__bold">
        {toCurrency(price || subscriptionPricePerServing)}
      </span>
    );

  return (
    <>
      <span>
        { salesPrice && salesPrice !== subscriptionPricePerServing
        && servings !== undefined && !(servings > 1) ? (
          <>
            <span className="c-recipe__discounted_price">
              {toCurrency(salesPrice)}
            </span>
            {' '}
            <span className="c-recipe__strikethrough_price">
              {toCurrency(subscriptionPricePerServing)}
            </span>
          </>
          ) : (
            <>
              {planGroup === 'prepared_one_serving' ? (
                <>
                  <span className="c-product-package-sku-price__bold">
                    {toCurrency(price || subscriptionPricePerServing)}
                  </span>
                  { !isPDPPackageProduct && ' / each'}
                </>
              ) : servingText }
            </>
          )}
      </span>
      {!!spec && !isPDPPackageProduct && ` / ${spec}`}
    </>
  );
}
export default ProductPackageSkuPrice;
